import { getApiCall } from "./tokenService";
import { EventLogItems } from "../models/eventLog/eventLogItems";

export const getEventLogs = (pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<EventLogItems> => {
    return getApiCall<EventLogItems>("api/eventlog/?page=" + (page || "") + "&pageSize=" + (pageSize || "") +
        "&sortColumn=" + (sortColumn ? encodeURIComponent(sortColumn) : "") + "&sortOrder=" + (sortOrderIsAsc ? "asc" : "desc") +
        "&filter=" + (filter ? encodeURIComponent(filter) : ""), EventLogItems);
};